export default "__VITE_ASSET__COhgpkrh__"